import { c as _c } from "react/compiler-runtime";
import { GenericLayout } from '@src/components/sco/GenericLP/GenericLayout';
import { HomeLandingSection } from '@src/components/sco/Home/sections/HomeLandingSection';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default function Page() {
  const $ = _c(4);
  const activeContent = useActiveContentContext();
  let t0;
  if ($[0] !== activeContent) {
    t0 = () => {
      activeContent.setSiteSection("home.landing");
      activeContent.setItem({
        __typename: "LandingPage",
        title: "Startup Growth Engine",
        description: "Grow like your team just got 10x bigger. Pitch decks, investor matching, and advisors in one platform \u2014 so you can launch and scale without giving up equity."
      });
      return () => activeContent.setItem(null);
    };
    $[0] = activeContent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useUniversalEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GenericLayout appLayoutId="home-landing"><HomeLandingSection /></GenericLayout>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}